import React, { useState } from 'react';
import Child from "./Child";
// import Child from "../notification/Child";

export default props => {
  const [dSearch, setSearch] = useState("none");
  const [vInputWord, setInputWord] = useState("");

  if (process.browser) window.unsets.unsetSearch = () => setSearch("none");

  const jsx = (<div className="dib search-binder">
    <style jsx>{`
span{
	float: left;
}


.search-input {
  background-color: #f5f5f5;
  -o-border-radius: 4px;
  -ms-border-radius: 4px;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  width: 400px;
  height: 40px;
  padding: 6px 12px;

  background-image: url('/assets/images/ico-search.svg');
  background-repeat: no-repeat;
  background-position: left;
  background-position-x: 10px;
  text-indent: 20px;

  font-size:16px;
	margin: 0;
	border: 0;

}

.search-binder {
  width:400px;
}

@media all and (max-width:606px) {
  .search-binder {
  width:100%;
}


  .search-input{
    min-width: 255px;
    width: 70%;
  }
}

.display-inline{
  display:inline;
}

.ham2{
  display:none;
}

@media all and (max-width:606px) {
  .ham{
    position: absolute;
    left: 0px;
    top: 8px;
  }

  .ham2{
    display:none;
    position: absolute;
    top: -11px;
    right: -12px;
    width: 14%;
    height: 60px;
    background-color: white;
    padding: 18px 0;

    z-index: 3;
  }

  
  .hamberger{
    width:24px;
    height:24px;
  }
}


`}</style>
    <div className="ham dibom" onClick={props.showMenu}>
      <img className="hamberger " style={{ display: dSearch == "none" ? "block" : "none" }} src="/assets/images-m/group-6.svg" />
      <img className="hamberger " style={{ display: dSearch }} src="/assets/images-m/back-gray.svg" onClick={(e) => e.stopPropagation()} />
    </div>

    <div className="display-inline binder"
      style={{ display: ((props.isCommunity ? "inline-block" : "none")) }}
    >
      <form>
        <input className="search-input" type="input" placeholder="키워드 입력, 아래에서 선택" autoComplete="none"
          value={vInputWord}
          onClick={() => { setSearch("block") }}
          onChange={e => {
            setInputWord(e.target.value);
            (e.target.value == ''?setSearch("none"):setSearch("block"));
          }}
          onKeyDown={e => {
            if (e.keyCode == 13) {
              e.preventDefault();
              e.stopPropagation();
            }
          }}

        />
      </form>
      <Child dSearch={dSearch} hide={() => setSearch('none')} keyword={vInputWord} />

    </div>

{/* - 검색 창에서 오른 편의 'X' 없애기 */}
    {/* <div className="ham2" style={{ display: dSearch }}>
      <img className="hamberger dibom" src="/assets/images-m/x_2.svg" />
    </div> */}

  </div>);
  return (jsx);
}
